// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__GfIbw","nextBtn":"styles_nextBtn__xCIOD","submitBtn":"styles_submitBtn__TXusD","arrowIcon":"styles_arrowIcon__qjuNa"};